import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { VendorLinkBulkImport } from './VendorLinkBulkImport';
import { Main } from 'Containers/';
import * as VendorLinkIntegrationSelectors from 'Pages/vendorlinkintegration/state/selectors';
import * as VendorLinkIntegrationActions from 'Pages/vendorlinkintegration/state/actions';
import { successToast, toastType } from 'Common/ToastHelper';
import * as DialogActions from 'Components/dialogs/state/actions';

export class VendorLinkImportStepContainer extends Component {
  static stepInfo = {
    icon: 'file text',
    title: 'Manual Import',
    description: 'Import your data.',
  };

  componentDidUpdate(prevProps) {
    const {
      bulkImportIsComplete,
      setBulkImportComplete,
      setBulkImportLoading,
      bulkImportLoading,
      notifications,

      setStepCompleted,
    } = this.props;

    // Bulk Import
    if (!prevProps.bulkImportIsComplete && bulkImportIsComplete) {
      setStepCompleted(true);
    }

    const firstTitle = get(notifications, '[0].Title');

    if (
      bulkImportLoading &&
      get(notifications, 'length', 0) >
        get(prevProps, 'notifications.length', 0) &&
      (firstTitle === 'VendorLink Import Complete' ||
        firstTitle === 'VendorLink Import Failed')
    ) {
      setBulkImportComplete(true);
      setBulkImportLoading(false);
    }
  }

  /** The "Are you sure?" for the the Bulk Import */
  areYouSureYouWantToBulkImport = () => {
    return new Promise(resolve => {
      this.props.setYesNoDialogProps({
        showDialog: true,
        title: 'Import',
        question:
          "This import may have adverse effects on on your current data. Are you sure you'd like to import?",
        yesCallback: () => resolve(true),
        noCallback: () => resolve(false),
        cancelCallback: () => resolve(false),
      });
    });
  };

  getMainProps = () => {
    const {
      bulkImportLoading,

      goToPreviousStep,
    } = this.props;

    const mainProps = {
      toolbox: {
        shown: true,
        backButtonProps: {
          shown: true,
          callback: goToPreviousStep,
        },
        rightButtons: [
          {
            content: 'Import',
            loading: bulkImportLoading,
            disabled: bulkImportLoading,
            onClick: async () => {
              if (await this.areYouSureYouWantToBulkImport()) {
                this.handleBulkImportSubmit();
              }
            },
          },
        ],
      },
    };

    return mainProps;
  };

  /** Called when you run the Bulk Import */
  handleBulkImportSubmit = () => {
    this.props.getBulkImport();
    successToast(toastType.success, 'Manual Import has started');
  };

  render() {
    const { bulkImportIsComplete, bulkImportLoading } = this.props;
    const mainProps = this.getMainProps();

    return (
      <Main {...mainProps}>
        <VendorLinkBulkImport
          isComplete={bulkImportIsComplete}
          loading={bulkImportLoading}
        />
      </Main>
    );
  }
}

const mapStateToProps = state => {
  return {
    bulkImportLoading: VendorLinkIntegrationSelectors.getBulkImportLoading(
      state
    ),
    bulkImportIsComplete: VendorLinkIntegrationSelectors.getBulkImportIsComplete(
      state
    ),

    notifications: VendorLinkIntegrationSelectors.getNotifications(state),
  };
};

const mapDispatchToProps = {
  getBulkImport: VendorLinkIntegrationActions.bulkImport,
  setBulkImportLoading: VendorLinkIntegrationActions.updateIsBulkImportLoading,
  setBulkImportComplete:
    VendorLinkIntegrationActions.updateIsBulkImportComplete,

  setYesNoDialogProps: DialogActions.setYesNoDialogProps,
};

export const VendorLinkImportStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorLinkImportStepContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkImportStep/VendorLinkImportStep.js